import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import PageBookLibraryShares from 'teacher-ui-client/components/page/book-library/shares'
import type BookLibrarySharesIndexRoute from 'teacher-ui-client/subscription-type/book-library/shares/index/route'

interface Signature {
  Args: {
    model: ModelFor<BookLibrarySharesIndexRoute>
  }
}
export const BookLibrarySharesIndexPage: TOC<Signature> = <template>
  <PageBookLibraryShares @subscriptionType={{@model.subscriptionType}}>
    <:table>{{outlet}}</:table>
  </PageBookLibraryShares>
</template>

export default RouteTemplate(BookLibrarySharesIndexPage)
